import { Form, Record } from '@fulcrumapp/fulcrum-core';
import {RestApiForm} from "../types";

export default function parseRecordTitle(recordData: object, restForm: RestApiForm): string {
  const form = new Form(restForm);
  const record = new Record(recordData, form);
  return record.displayValue || 'Untitled Record';
}
